import { ConstructionStatus } from '@lopo-tech/lopo-api'

type ConstructionStatusKey =
  | 'preliminaryPlanning'
  | 'planning'
  | 'underConstruction'
  | 'completed'

// Full Record on purpose: a fifth enum value shows up as a type error on the next
// lopo-api bump instead of silently falling through. The build itself is babel and
// does not read these types, so it keeps working either way.
const CONSTRUCTION_STATUS_KEYS: Record<ConstructionStatus, ConstructionStatusKey> = {
  [ConstructionStatus.PreliminaryPlanning]: 'preliminaryPlanning',
  [ConstructionStatus.Planning]: 'planning',
  [ConstructionStatus.UnderConstruction]: 'underConstruction',
  [ConstructionStatus.Completed]: 'completed'
}

// The texts come in as a parameter, and the block is optional here: white-label forks
// of @lopo-tech/frontends-shared can lag behind and ship project text resources
// without it. The index signature is what makes such a set assignable at all: with
// optional properties only, this is a weak type, and TypeScript rejects an argument
// that shares no property with it.
type ProjectsTextResources = {
  constructionStatus?: Partial<Record<ConstructionStatusKey, string>>;
  [key: string]: unknown;
};

export const getConstructionStatusLabel = (
  textResources: ProjectsTextResources,
  status?: ConstructionStatus | null
): string | undefined => {
  if (!status) {
    return undefined
  }

  const key = CONSTRUCTION_STATUS_KEYS[status]

  return key ? textResources.constructionStatus?.[key] : undefined
}
